export default __webpack_public_path__ + "static/media/SD-chandi-homam-img.05bc3438.png";